import type { Control } from "react-hook-form";

import { type UpdateProfileBody, UserRoleEnum } from "@nlc/shared-types";
import { Controller } from "react-hook-form";

import { Input, Label, TextField } from "@/components/field";
import {
  Select,
  SelectButton,
  SelectListBox,
  SelectListItem,
  SelectPopover,
} from "@/components/select";
import { useResolveDesignations } from "@/features/users/hooks/useResolveDesignations";

interface ProfileTeamFieldsProps {
  control: Control<UpdateProfileBody>;
  isDisabled?: boolean;
  isSuperAdmin?: boolean;
  roleId?: number;
  showDesignationOnly?: boolean;
  showInitialsAndTeamOnly?: boolean;
  team?: string;
}

export function ProfileTeamFields({
  control,
  isDisabled = false,
  isSuperAdmin = false,
  roleId,
  showDesignationOnly = false,
  showInitialsAndTeamOnly = false,
  team,
}: ProfileTeamFieldsProps) {
  const { data: designations } = useResolveDesignations(roleId);

  if (isSuperAdmin) return;

  if (showDesignationOnly) {
    return (
      <Controller
        control={control}
        name="designationId"
        render={({ field }) => (
          <TextField>
            <Label>Designation</Label>
            <Select
              isDisabled={isDisabled}
              onSelectionChange={field.onChange}
              selectedKey={field.value ?? null}
            >
              <SelectButton />
              <SelectPopover>
                <SelectListBox>
                  {designations?.map((d) => (
                    <SelectListItem id={d.id} key={d.id}>
                      {d.name}
                    </SelectListItem>
                  ))}
                </SelectListBox>
              </SelectPopover>
            </Select>
          </TextField>
        )}
      />
    );
  }

  if (showInitialsAndTeamOnly) {
    return (
      <>
        {/* TODO: This feature will be refactored and improved in the future.
         <Controller
          control={control}
          name="initials"
          render={({ field }) => (
            <TextField
              className={
                roleId === UserRoleEnum.CustomerSuccess ? "col-span-full" : ""
              }
            >
              <Label>Initials</Label>
              <Input
                {...field}
                disabled={isDisabled}
                placeholder="ABC"
                value={field.value || ""}
              />
            </TextField>
          )}
        /> */}

        {roleId !== UserRoleEnum.CustomerSuccess && (
          <TextField>
            <Label>Team</Label>
            <Input disabled value={team || ""} />
          </TextField>
        )}
      </>
    );
  }

  return (
    <>
      <Controller
        control={control}
        name="designationId"
        render={({ field }) => (
          <TextField>
            <Label>Designation</Label>
            <Select
              isDisabled={isDisabled}
              onSelectionChange={field.onChange}
              selectedKey={field.value ?? null}
            >
              <SelectButton />
              <SelectPopover>
                <SelectListBox>
                  {designations?.map((d) => (
                    <SelectListItem id={d.id} key={d.id}>
                      {d.name}
                    </SelectListItem>
                  ))}
                </SelectListBox>
              </SelectPopover>
            </Select>
          </TextField>
        )}
      />

      {/* TODO: This feature will be refactored and improved in the future. 
      <Controller
        control={control}
        name="initials"
        render={({ field }) => (
          <TextField>
            <Label>Initials</Label>
            <Input
              {...field}
              disabled={isDisabled}
              placeholder="ABC"
              value={field.value || ""}
            />
          </TextField>
        )}
      /> */}

      <TextField>
        <Label>Team</Label>
        <Input disabled value={team || ""} />
      </TextField>
    </>
  );
}
